var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_676_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5582C16.9706 21.5582 21 17.5288 21 12.5582C21 7.58766 16.9706 3.55823 12 3.55823C7.02944 3.55823 3 7.58766 3 12.5582C3 17.5288 7.02944 21.5582 12 21.5582Z",
    fill: "#1851B0",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5582L12 15.5582L16 11.5582",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_676_4015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24.5582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.82bb7be28752d3aa5a56ce4cf386cff0.svg";
export { ForwardRef as ReactComponent };